import React from "react";

export const StatBlock = ({ label, value, hint, accent, testId }) => (
  <div
    className={`border ${accent ? "border-[#0A0A0A]" : "border-black/15"} bg-white p-5`}
    data-testid={testId}
  >
    <div
      className="text-[10px] tracking-[0.25em] uppercase text-[#525252]"
      style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 700 }}
    >
      {label}
    </div>
    <div
      className={`mt-2 leading-none tabular-nums ${accent ? "text-[#0047FF]" : "text-[#0A0A0A]"}`}
      style={{ fontFamily: "'IBM Plex Mono', monospace", fontWeight: 700, fontSize: "2.5rem" }}
    >
      {value}
    </div>
    {hint && (
      <div className="mt-2 text-xs text-[#525252]" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
        {hint}
      </div>
    )}
  </div>
);

export const PrimaryButton = ({ children, onClick, disabled, testId, className = "" }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    disabled={disabled}
    className={`bg-[#0047FF] text-white px-4 py-2.5 text-xs tracking-[0.2em] uppercase shadow-[2px_2px_0px_#0A0A0A] hover:bg-[#0038CC] active:translate-y-[2px] active:translate-x-[2px] active:shadow-none disabled:bg-[#525252] disabled:cursor-not-allowed transition-colors duration-150 ${className}`}
    style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 700 }}
  >
    {children}
  </button>
);

export const SecondaryButton = ({ children, onClick, disabled, testId, className = "", as = "button", href }) => {
  const cls = `bg-transparent border border-black text-black px-4 py-2.5 text-xs tracking-[0.2em] uppercase hover:bg-black/5 active:translate-y-[1px] disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-150 inline-flex items-center gap-2 ${className}`;
  const style = { fontFamily: "'Chivo', sans-serif", fontWeight: 700 };
  if (as === "a") {
    return (
      <a href={href} data-testid={testId} className={cls} style={style}>
        {children}
      </a>
    );
  }
  return (
    <button data-testid={testId} onClick={onClick} disabled={disabled} className={cls} style={style}>
      {children}
    </button>
  );
};

export const SectionTitle = ({ overline, title, children }) => (
  <div className="mb-6 flex items-start justify-between gap-4 flex-wrap">
    <div>
      {overline && (
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#525252] mb-2" style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 700 }}>
          {overline}
        </div>
      )}
      <h1
        className="text-3xl sm:text-4xl leading-none tracking-tight"
        style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 800 }}
      >
        {title}
      </h1>
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const EmptyState = ({ icon, title, hint, action }) => (
  <div className="border border-dashed border-black/25 p-10 text-center bg-white" data-testid="empty-state">
    {icon && <div className="mx-auto w-12 h-12 bg-[#0A0A0A] text-[#D4FF00] flex items-center justify-center mb-4">{icon}</div>}
    <div className="text-base" style={{ fontFamily: "'Chivo', sans-serif", fontWeight: 700 }}>{title}</div>
    {hint && <div className="text-sm text-[#525252] mt-2 max-w-md mx-auto">{hint}</div>}
    {action && <div className="mt-6">{action}</div>}
  </div>
);
